export class DuplicateUserParam {
    public dni: boolean
    public phone: boolean
    public userName: boolean
    public email: boolean


    /**
     * @description
     *	Construye un duplicateUserParam con una semántica vacía.  Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
     *        - Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un duplicateUserParam vaico.
     */

    public static empty(): DuplicateUserParam{
        const duplicateUserParam: DuplicateUserParam = new DuplicateUserParam();
        duplicateUserParam.dni = false;
        duplicateUserParam.phone = false;
        duplicateUserParam.userName = false;
        duplicateUserParam.email = false;
        return duplicateUserParam;
    }

    /**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicDuplicateUserParam
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
    public static from(anemicDuplicateUserParam: DuplicateUserParam): DuplicateUserParam {
        if(!anemicDuplicateUserParam) return undefined;
        const duplicateUserParam: DuplicateUserParam = DuplicateUserParam.empty();
        duplicateUserParam.dni = anemicDuplicateUserParam.dni;
        duplicateUserParam.phone = anemicDuplicateUserParam.phone;
        duplicateUserParam.userName = anemicDuplicateUserParam.userName;
        duplicateUserParam.email = anemicDuplicateUserParam.email;
        return duplicateUserParam;


    }
}
